import { loadSegmentsAnalytics } from './loadSegmentAnalytics';
import { getConfigByBrand } from '../../utilities/index.js';
export default async function ensureSegmentAnalytics(options, metadata) {
  if (options === void 0) {
    options = {};
  }
  const {
    initialConfig = {},
    brand = ''
  } = options;

  // define the key where the global analytics object will be accessible
  // customers can safely set this to be something else if need be
  const globalAnalyticsKey = 'analytics';
  const writeKey = initialConfig.segment?.writeKey || getConfigByBrand(brand) || '';
  const segment = globalThis[globalAnalyticsKey] || loadSegmentsAnalytics({
    globalAnalyticsKey,
    writeKey
  });
  return segment;
}